export default {
  layout: [[]],
  components: {},
  componentsCopy: {},
  document: [],
  content: [],
  documentTypes: [],
  clauses: [],
  document_order: [],
  selectedDocCategory: "",
  docStatusConfigs: [],
  draggedSection: null,
  draggedFrom: null,
  showDocumentDiffView: false,
  // asset library state below
  selectedAccount: {},
  accountDocs: [],
  accountGlobalDocs: [],
  opportunities: [],
  // toolspane state
  toolsView: "",
  // approval related state
  docAnalysis: [],
  docApprovalStatus: [],
  docPendingApprovers: [],
  docAllApprovers: [],
  collaboratorsData: [],
  hoveredActiveComponentId: null,
  pendingApprovalRequired: false,
  acceptorsList: [],
  // formMode data
  docForm: [],
  isDocFormValid: false,
  showIframeView: false,
  signatureIFrameURL: "",
  signatureEnvelopeID: "",
  // Editor active/in-active flag & type
  clickedActiveComponentId: null,
  clickedActiveComponentType: null,
  preventClickedComponentIdUpdate: true,
  preventEditorFocusOnDrag: true,
  forceInitEditorState: null,
  customColorDropdownStatus: false,
  hasQuoteTableWrapper: false,
  isDocumentLocked: false,
  // Document Recipient List
  docRecipientList: [],
  // Coverpage toggle
  toggleCoverPageView: false,
  activities: [],
  hasMoreActivities: false,
  connectedGSheetSections: [],
  // GoogleSheet Related key
  isGoogleSheetAuthenticated: false,
  lastEmailSentAt: "",
  emailMessage: "",
  // Undo/Redo Stack Data (Used as data layer & not injected in UI)
  stack: {
    id: "", // acts as a flag when undo/redo action is performed, used for rerendering component
    undo: [],
    redo: [],
  },
  // isCoverpageThemePaneOpen: false,
  // isCustomizeCoverpagePaneOpen: false,
  coverpageThemeActionLabel: null,
  activeComponentMeta: {},
  docSaveIndicator: "SAVED",
  signers: [],
  // stripe data
  stripePaymentDetails: null,
  stripeButtonSessionId: null,
  stripePaymentButtonDetails: [],
  stripeFlag: true,
  forceUpdateEditorSectionId: null,
  sharedUsersSender: [],
  videoKycUrl: "",
  pdfFormFields: null,
  isFillablePDF: false,
  isDynamicPDF: false,
  reCalculatePageBreaks: false,
  pageBreakScrollToView: null,
  currentZoom: null,
  tableSelectionType: null,
  totalNumberOfPages: null,
  tables: null,
  pastedTempImage: null,
  pastedImageSectionID: null,
};
